import { useContext, useEffect, useState, useRef } from "react";
import { Box, Container, Grid, Rating, styled } from "@mui/material";
import { Icon } from "@iconify/react";
import { createSearchParams, useNavigate } from "react-router-dom";
import { LocaleContext } from "../../routing/LangRouter";
import { ArrowLeft, SearchNormal } from "iconsax-react";
import axios from "axios";
import BASE_URL from "../../constants/baseUrls";

//import general components
import { BaseButton } from "../../components/common/base-button/base-button";
import MobileHeader from "../../components/common/mobile-header/mobile-header";

//import styles
import "./location.scss";

//import images
import BaseSort from "../../components/common/base-sort/base-sort";
import { t } from "i18next";
// import BaseFilter from "../../components/common/base-filter/base-filter";

function Location() {
    const { locale } = useContext(LocaleContext);
    const locationRef = useRef(null);

    //options sort
    const optionListSort = [
        { value: "mostVisit", label: "پربازدیدترین ها" },
        { value: "mostLike", label: "محبوب ترین ها" },
    ];

    //custom rating
    const StyledRating = styled(Rating)({
        direction: "ltr",
        "& .MuiRating-iconFilled": {
            color: "#0F0067",
        },
        "& .MuiRating-iconHover": {
            color: "#0F0067",
        },
    });

    //request get category list
    const [categoryList, setCategoryList] = useState([]);
    const getCategoryList = async () => {
        const responsive = await axios.get(`${BASE_URL}/location/category/list/`);
        setCategoryList(responsive.data.results);
    };

    //request get location list
    const [locationList, setLocationList] = useState(null);
    const [searchedLocationList, setSearchedLocationList] = useState(null);
    const getLocationList = async () => {
        const response = await axios.get(`${BASE_URL}/location/list/`, {
            params: {
                country: "",
                province: "",
                city: "",
                category: "",
            },
        });
        setLocationList(response.data.results);
        setSearchedLocationList(response.data.results);
    };
    useEffect(() => {
        getCategoryList();
        getLocationList();
    }, []);

    //set value radio button for sort
    const [sortValue, setSortValue] = useState();
    const handleSlectedRadio = value => {
        setSortValue(value);
        const sorted =
            value === "mostVisit"
                ? locationList.sort((a, b) => b.visit - a.visit)
                : value === "mostLike"
                ? locationList.sort((a, b) => b.like_count - a.like_count)
                : locationList;
        setSearchedLocationList(sorted);
    };

    //redirect to location information page with location id
    const navigate = useNavigate();
    const goToLocationInfo = id => {
        const params = { id };
        navigate({
            pathname: `/${locale}/location-information`,
            search: `?${createSearchParams(params)}`,
        });
    };

    //search
    const [search, setSearch] = useState("");
    const searchInputChange = event => {
        resetFilteredList();
        const searchValue = event.target.value;
        setSearch(searchValue);
    };

    const searchLocation = event => {
        event.preventDefault();
        resetFilteredList();
        const filteredLocation = locationList?.filter(item => {
            return item.name.includes(search);
        });
        setSearchedLocationList(filteredLocation);
    };
    const resetFilteredList = () => {
        setSearchedLocationList(locationList);
    };

    //go to home page
    const goTohome = () => {
        navigate(`/${locale}`, { replace: true });
    };

    return (
        <Box className={`location ${"animate__animated animate_fadeIn"}`} ref={locationRef}>
            {/* <Header></Header> */}
            <MobileHeader title="دیدنی ها" justifyContent="center" handleClick={goTohome}></MobileHeader>

            <Grid container rowGap={5}>
                <Grid className="location__search" container item xs={12} justifyContent="center" alignItems="center">
                    <Grid container item xs={9} md={3} justifyContent="center">
                        <Grid container item xs={11}>
                            <input
                                className="location__search-text"
                                value={search}
                                onChange={searchInputChange}
                                placeholder={t("enterLocationPlaceholder")}
                            ></input>
                        </Grid>
                        <Grid container item xs={1}>
                            <BaseButton
                                size="large"
                                radius="left-10"
                                rightIcon={<SearchNormal size="24" color="#5E5E5E" variant="Outline" />}
                                handleClick={searchLocation}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Container className="location__container" maxWidth="xl">
                    <Grid container item xs={12} justifyContent="space-between" alignItems="flex-start">
                        <Grid container item xs={12} md={2} display={{ xs: "none", md: "flex" }} rowGap={4}>
                            <Grid item xs={12}>
                                <BaseSort optionList={optionListSort} handleChange={handleSlectedRadio}></BaseSort>
                            </Grid>
                            {/* <Grid item xs={12}><BaseFilter optionList={categoryList}></BaseFilter></Grid> */}
                        </Grid>

                        <Grid className="location__location-list" container item xs={12} md={9.8} rowGap={3}>
                            {searchedLocationList
                                ? searchedLocationList.map(item => {
                                      return (
                                          <Grid
                                              className="location__location-item"
                                              key={item.id}
                                              container
                                              item
                                              xs={12}
                                              rowGap={2}
                                              justifyContent="space-between"
                                          >
                                              <Grid container item xs={12} justifyContent="flex-start" display={{ xs: "flex", md: "none" }}>
                                                  <Grid
                                                      className="location__information-category location__information-category--historical"
                                                      container
                                                      item
                                                      xs={2}
                                                      justifyContent="center"
                                                      alignItems="center"
                                                  >
                                                      <span>{item.category}</span>
                                                  </Grid>
                                              </Grid>

                                              <Grid container item xs={12} md={10}>
                                                  <Grid
                                                      className="location__location-img"
                                                      container
                                                      item
                                                      xs={2}
                                                      md={2}
                                                      justifyContent="center"
                                                      alignItems="center"
                                                  >
                                                      <img src={"https://api.atripa.com" + item.image} alt="" />
                                                  </Grid>
                                                  <Grid className="location__location-information" container item xs={10} rowGap={1}>
                                                      <Grid item xs={6} order={{ xs: 1, md: 1 }}>
                                                          <span className="location__information-title">{item.name}</span>
                                                      </Grid>

                                                      <Grid
                                                          container
                                                          item
                                                          xs={6}
                                                          justifyContent="flex-end"
                                                          display={{ xs: "none", md: "flex" }}
                                                          order={2}
                                                      >
                                                          <Grid
                                                              className="location__information-category location__information-category--historical"
                                                              container
                                                              item
                                                              xs={3.7}
                                                              justifyContent="center"
                                                              alignItems="center"
                                                          >
                                                              <span>{item.category}</span>
                                                          </Grid>
                                                      </Grid>

                                                      <Grid container item xs={12} md={6} alignItems="center" order={{ xs: 3, md: 3 }}>
                                                          <span className="location__information-address">
                                                              {" "}
                                                              {item.address.country.name} {item.address.province.name} {item.address.city.name}{" "}
                                                          </span>
                                                      </Grid>

                                                      <Grid
                                                          container
                                                          item
                                                          xs={6}
                                                          justifyContent="flex-end"
                                                          alignItems="center"
                                                          order={{ xs: 2, md: 4 }}
                                                      >
                                                          <span className="location__information-view">{item.visit}</span>
                                                          <Icon icon="ic:baseline-remove-red-eye" color="#3d3d3d" width="20" height="20" />
                                                      </Grid>

                                                      <Grid
                                                          className="location__location-descripton"
                                                          item
                                                          xs={12}
                                                          display={{ xs: "none", md: "flex" }}
                                                          order={5}
                                                      >
                                                          {item.description}
                                                      </Grid>
                                                  </Grid>
                                              </Grid>

                                              <Grid
                                                  className="location__location-details"
                                                  container
                                                  item
                                                  xs={12}
                                                  md={2}
                                                  justifyContent="space-between"
                                                  alignItems="center"
                                              >
                                                  <Grid container item xs={7} md={12} rowGap={{ xs: 0, md: 1 }} order={{ xs: 2, md: 1 }}>
                                                      <Grid item xs={6} md={12}>
                                                          <span className="location__score">امتیاز کاربران</span>
                                                      </Grid>
                                                      <Grid
                                                          container
                                                          item
                                                          xs={6}
                                                          md={12}
                                                          justifyContent={{ xs: "space-evenly", md: "space-between" }}
                                                          alignItems="center"
                                                      >
                                                          <StyledRating
                                                              name="customized-color"
                                                              defaultValue={item.rating}
                                                              getLabelText={value => `${value} Heart${value !== 1 ? "s" : ""}`}
                                                              icon={<Icon icon="mdi:circle-slice-8" color="#0f0067" width="14" height="14" />}
                                                              emptyIcon={<Icon icon="material-symbols:circle-outline" width="14" height="14" />}
                                                              readOnly
                                                          />
                                                          {item.rating}
                                                      </Grid>
                                                      <Grid item xs={12}>
                                                          <span className="location__count-comment">{item.comment_count} نظر</span>
                                                      </Grid>
                                                  </Grid>

                                                  <Grid item xs={4} md={12} order={{ xs: 1, md: 2 }}>
                                                      <BaseButton
                                                          text="اطلاعات بیشتر"
                                                          color="outline"
                                                          size="large"
                                                          radius="all"
                                                          leftIcon={<ArrowLeft size="24" color="#0F0067" variant="Outline" />}
                                                          handleClick={() => goToLocationInfo(item.id)}
                                                      />
                                                  </Grid>
                                              </Grid>
                                          </Grid>
                                      );
                                  })
                                : ""}
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
        </Box>
    );
}

export default Location;
